"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundraiseServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class FundraiseServiceLive {
    async cancelFundraiseOffer(companyId, emailDetailsRequestBody) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/fundraise-offers/cancel`, emailDetailsRequestBody);
        return response.data;
    }
    async reconcileFundraiseOffer(companyId, fundraiseOfferId, requestBody = {}) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraise-offers/${fundraiseOfferId}/reconcile`, requestBody);
        return response.data;
    }
    async resendFundraiseOffer(companyId, fundraiseOfferId, actionedByUser) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraise-offers/${fundraiseOfferId}/resend`, {
            actionedByUser,
        });
        return response.data;
    }
    async deleteFundraiseRound(companyId, fundraiseId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/fundraises/${fundraiseId}`);
        return response.data;
    }
    async updateFundraiseRound(companyId, fundraiseId, fundraiseData) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/fundraises/${fundraiseId}`, fundraiseData);
        return response.data;
    }
    async getDefaultFundraiseFee(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraises/fee/default`);
        return response.data;
    }
    async acceptFundraiseTnc(companyId, acceptFundraiseTncRequestBody) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraises/fundraise-tnc/accept`, acceptFundraiseTncRequestBody);
        return response.data;
    }
    async generateFundraiseTnc(companyId, fee) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraises/fundraise-tnc/generate`, { fee });
        return response.data;
    }
    async getFundraises(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraises`);
        return response.data;
    }
    async issueFundraiseOfferToExistingShareholder(companyId, shareholderId, issueFundraiseOfferToExistingShareholderRequestBody) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/fundraise-offers/${shareholderId}`, issueFundraiseOfferToExistingShareholderRequestBody);
        return response.data;
    }
    async issueFundraiseOfferToNewShareholder(companyId, issueFundraiseOfferToNewShareholderRequestBody) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraise-offers`, issueFundraiseOfferToNewShareholderRequestBody);
        return response.data;
    }
    async uploadSubscriptionAgreement(companyId, fundraiseId, docFile) {
        const formData = new FormData();
        formData.append("doc", docFile, docFile.name);
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraises/${fundraiseId}/subscription-agreement-template`, formData);
        return response.data;
    }
    async getSubscriptionAgreementTemplate(companyId, fundraiseId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraises/${fundraiseId}/subscription-agreement-template`);
        return response.data;
    }
    async getShareholderSubscriptionAgreement(companyId, fundraiseId, fundraiseOfferId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraises/${fundraiseId}/subscription-agreements/${fundraiseOfferId}`);
        return response.data;
    }
    async updateFundraiseOffer(companyId, fundraiseOfferId, fundraiseOfferUpdate) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/fundraise-offers/${fundraiseOfferId}`, fundraiseOfferUpdate);
        return response.data;
    }
    async getFundraiseOffersForShareholder(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraise-offers/shareholder/${shareholderId}`);
        return response.data;
    }
    async getFundraiseOffer(companyId, fundraiseOfferId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraise-offers/${fundraiseOfferId}/shareholder/${shareholderId}`);
        return response.data;
    }
    async getFundraiseOfferDetails(companyId, fundraiseId, keyword, fundraiseOfferType, page, rowsPerPage, sortBy, sortOrder) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraise-offers/fundraise-offer-details/${fundraiseId}?keyword=${keyword}&activeFundraiseType=${fundraiseOfferType}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`);
        return response.data;
    }
}
exports.FundraiseServiceLive = FundraiseServiceLive;
//# sourceMappingURL=FundraiseServiceLive.js.map